var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11H13V7.5c0-.3-.7-.5-1-.5s-1 .2-1 .5V11H7.5c-.3 0-.5.7-.5 1s.2 1 .5 1H11v3.5c0 .3.7.5 1 .5s1-.2 1-.5V13h3.5c.3 0 .5-.7.5-1s-.2-1-.5-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4.5 10 10-4.5 10-10 10zm0-22C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12c0-3.2-1.3-6.2-3.5-8.5C18.2 1.3 15.2 0 12 0z"
  })));
}

export default SvgAddCircle;